// 纵向基础柱状图
import { Tooltip, Legend } from "dependencies/bigScreen/publicChartOptions/options"
export const chartOption1 = {
  styleId:1,
  pluginName: ["formatterValToPercentage"],
  isShowDataName: true, // 是否显示数据名称  单独列出来是因为formatter里面取不到百分比的值，formatter使用插件 function, 因此回显无法判断
  refreshTime: 90000,
  seriesTempAttributes: {
    // 用于存放数据中的通用配置项
    coordinateType: "" //不带坐标系
  },

  title: {
    text: "title",
    left: "center",
    show: false
  },
  tooltip: new Tooltip("item", {}),
  legend: new Legend({
    left: "center",
    top: "top",
    textStyle: {
      color: "rgba(255,255,255,1)",
      fontWeight: "400",
      fontSize: 14
    }
  }),
  series: [
    {
      type: "liquidFill",
      radius: "85%",
      center: ["50%", "50%"],
      waveAnimation: true, //波纹是否移动
      animationDuration: 0, //禁止上下移动
      animationDurationUpdate: 0, //禁止上下移动
      data: [
        {
          value: 0.5,
          max: 100,
          name: "数据1",
          itemStyle: {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: "rgba(0, 71, 255, 1)"
                },
                {
                  offset: 1,
                  color: "rgba(0, 228, 228, 1)"
                }
              ],
              globalCoord: false
            }
          }
        }
      ], // data个数代表波浪数
      backgroundStyle: {
        borderWidth: 1,
        color: "rgba(0,0,0,0)"
      },
      label: {
        show: true,
        formatter: "{c}{valueUnit|%}\n{b|{b}}",
        fontFamily: "Source Han Sans CN",
        color: "rgba(1, 172, 238, 1)",
        fontWeight: "500",
        fontSize: 50,
        rich: {
          valueUnit: { fontSize: 36, fontWeight: "400", fontFamily: "sans-serif", color: "rgba(1, 172, 238, 1)" },
          b: {
            fontSize: 16,
            fontWeight: "400",
            fontFamily: "sans-serif",
            color: "rgba(0, 0, 0, 0.6)",
            padding: [10, 0, 10, 0]
          }
        }
      },
      outline: {
        show: true,
        borderDistance: 10,
        itemStyle: {
          borderWidth: 3,
          borderColor: "rgba(1, 172, 238, 1)"
        }
      }
    }
  ]
}
